import $ from "jquery";

$.validator.setDefaults({
    ignore: '[readonly=readonly], [validation-client-ignore=true], :not(:visible):not([data-validate-hidden])',
    focusInvalid: false,
    errorClass: "is-invalid input-validation-error",
    highlight: function (element) {
        element.closest(".form-group").classList.add("invalid-group");
    },
    unhighlight: function (element) {
        element.closest(".form-group").classList.remove("invalid-group");
        element.classList.remove("is-invalid");
    }
});

$.validator.unobtrusive.options = $.validator.defaults;

$.extend($.validator.messages, {
    required: jQuery.validator.format("{0} är obligatoriskt."),
    remote: "Rätta till detta fält.",
    email: "Du måste ange en korrekt epostadress.",
    url: "Du måste ange en korrekt url.",
    date: "Du måste ange ett korrekt datum.",
    dateISO: "Du måste ange ett korrekt datum (ÅÅÅÅ-MM-DD).",
    number: "Du måste ange ett korrekt numerisk värde.",
    digits: "Du får bara ange siffror.",
    creditcard: "Du måste ange ett korrekt kortnummer.",
    equalTo: "Du måste upprepa värdet från förra fältet.",
    accept: "Du måste ange ett värde med .",
    maxlength: jQuery.validator.format("Du får bara ange ett värde som är högst {0} tecken långt."),
    minlength: jQuery.validator.format("Du får bara ange ett värde som är minst {0} tecken långt."),
    rangelength: jQuery.validator.format("Du får bara ange ett värde som är mellan {0} och {1} tecken långt."),
    range: jQuery.validator.format("Du får bara ange ett värde som är mellan {0} och {1}."),
    max: jQuery.validator.format("Du får bara ange ett värde som är högst {0}."),
    min: jQuery.validator.format("Du får bara ange ett värde som är minst {0}.")
});